module.exports = __webpack_public_path__ + "static/media/test1920x823.c732c86b.jpg";